<template>
    <div class="p-discount-rate-comparison__pie">
        <h3 v-if="title">
            {{ title }} ({{ rate }})
        </h3>
        <h3 v-else>
            {{ rate }}
        </h3>
        <pie-chart :chart-data="chartData" :options="chartOptions"></pie-chart>
        <br>
        <div class="u-text-center" v-if="total !== null">
            <strong>
                {{ totalText }}
            </strong>
            {{ currencyFormat(total) }}
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
    import currencyFormat from 'mixins/currencyFormat';
    import PieChart from 'components/graphs/PieChart.js';

    export default {
        name: 'pie',
        components: {
            PieChart,
        },
        mixins: [
            currencyFormat,
        ],
        props: {
            title: {
                type: String,
                default: null,
            },
            legend: {
                type: Boolean,
                default: true,
            },
            rate: {
                type: String,
            },
            total: {
                type: Number,
                default: null,
            },
            totalText: {
                type: String,
                default: 'Total'
            },
            dataset: {
                type: Array,
                default: null,
            },
            labels: {
                type: Array,
                default: null,
            }
        },
        computed: {
            chartData: {
                get() {
                    return {
                        labels: this.labels,
                        datasets: this.dataset,
                    };
                },
            },
            chartOptions: {
                get() {
                   return {
                        cutoutPercentage: 70,
                        legend: {
                            display: false,
                            position: 'bottom',
                            labels: {
                                boxWidth: 60,
                                fontSize: 16,
                                fontFamily: "'Nunito', sans-serif",
                                fontColor: "#000",
                                padding: 20,
                            },
                        },
                        tooltips: {
                            callbacks: {
                                label: (tooltipItem, data) => {
                                    return data.labels[tooltipItem.index] + ' - ' + this.currencyFormat(data.datasets[tooltipItem.datasetIndex]['data'][tooltipItem.index]);
                                },
                            },
                        },
                        title: {
                            display: true,
                            text: '',
                        },
                    };
                },
            },
        }
    }
</script>



// WEBPACK FOOTER //
// Pie.vue?c56e6142